export default __webpack_public_path__ + "static/media/404_icon.880e595a.png";